import { render, staticRenderFns } from "./list2_2.vue?vue&type=template&id=62931260&scoped=true&"
import script from "./list2_2.vue?vue&type=script&lang=js&"
export * from "./list2_2.vue?vue&type=script&lang=js&"
import style0 from "./list2_2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./list2_2.vue?vue&type=style&index=1&id=62931260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62931260",
  null
  
)

export default component.exports